import { Component } from '@angular/core';

@Component({
  templateUrl: './okta-auth.component.html',
})
export class OktaAuthComponent {
  constructor() {}
}
